module.exports = __webpack_public_path__ + "img/aguahuixquilucanx.b131adb5.jpg";